import PropTypes from 'prop-types';

export default {
  discountType: PropTypes.string.isRequired,
  discountValue: PropTypes.number.isRequired,
  minStay: PropTypes.number.isRequired,
  maxStay: PropTypes.number
};
